import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { DiscordInstance } from '../../discord/DiscordInstance.ts';
import { createDivIn, createExternalImgIn, createSpanIn, setElementInnerHTML, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { AnalyticEventCategory, AnalyticEventType, AnalyticEventValue } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../../../shared/scripts/analytics/Analytics.ts';
import IconDiscord from '@static/images/icon_discord.svg';
import { AudioManager, AudioType } from '@colonist/audio';
export class UIDRoomInviteFriendsController {
    setRoomId(roomId) {
        this.roomId = roomId;
    }
    static shouldHideInviteFriendsButton(discordInstance) {
        if (!discordInstance.inDiscordServer) return false;
        if (!discordInstance.canInviteFriends) return true;
        return false;
    }
    updateButtonTextWhileInviting() {
        const buttonTextChangeDuration = 3000;
        setElementInnerHTML(this.inviteFriendsButton, {
            key: 'strings:roomPage.inviting'
        });
        setTimeout(()=>this.setInviteFriendsButtonText(), buttonTextChangeDuration);
    }
    setInviteFriendsButtonText() {
        setElementInnerHTML(this.inviteFriendsButton, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        const textSpan = createSpanIn(this.inviteFriendsButton, 'btn_invite_friends_text', {
            key: 'strings:roomPage.inviteFriends'
        });
        textSpan.append(' ');
        createExternalImgIn(textSpan, IconDiscord, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
    }
    static sendClickAnalytic() {
        const eventData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.InviteFriendButtonLeft
        };
        void CA.sendAnalyticEvent(eventData);
    }
    deanimateInviteFriendsButton() {
        this.inviteFriendsButton.classList.remove('btn-wiggle');
    }
    animateInviteFriendsButton() {
        this.inviteFriendsButton.classList.add('btn-wiggle');
    }
    constructor(container){
        if (!UIUtilsEjsVariables.isUserOnDiscord) return;
        const inviteFriendsContainer = createDivIn(container, 'room_friend_container invite_discord_friends');
        if (UIUtilsEjsVariables.isUserOnDiscordMobile) inviteFriendsContainer.classList.add('discord_mobile');
        this.inviteFriendsButton = createDivIn(inviteFriendsContainer, 'btn_invite_friend btn_general');
        this.setInviteFriendsButtonText();
        const discordInstance = DiscordInstance.getDiscordInstance();
        if (UIDRoomInviteFriendsController.shouldHideInviteFriendsButton(discordInstance)) {
            inviteFriendsContainer.hidden = true;
            return;
        }
        setElementOnClick(this.inviteFriendsButton, ()=>{
            AudioManager.play(AudioType.Click);
            this.updateButtonTextWhileInviting();
            UIDRoomInviteFriendsController.sendClickAnalytic();
            discordInstance.inviteFriendsToRoom(this.roomId);
        });
        this.inviteFriendsButton.onmouseover = ()=>this.deanimateInviteFriendsButton();
    }
}
